(($, win) => {
    "use strict";

    $.enhancer("locationSearchOverlay", {
        settings: {
            mediaQuery: "(min-width: 768px)",
            initialized: false,
            minQueryCharLength: 2,
            element: null
        },
        searchOverlay: null,
        cityLocationId: null,
        remoteLocationButton: null,
        init: function (el) {
            
            const mediaQuery = win.matchMedia(this.settings.mediaQuery);

            mediaQuery.addListener((e) => {
                if (!this.settings.initialized && !e.matches) {
                    this.load(el);
                    this.bindEvents();
                }
                this.settings.initialized = true;
            });

            if (!this.settings.initialized && !mediaQuery.matches) {
                this.load(el);
                this.bindEvents();
                this.settings.initialized = true;
            }
        },
        load: function (el) {
            this.settings.element = $(el);
            this.remoteLocationButton = $(el.nextElementSibling);
            this.searchOverlay = new SearchOverlay(el);
        },
        bindEvents: function() {
            this.settings.initialized = true;
            this.searchOverlay.input.on("keyup", $.utils.debounce(this.handleInput, 300, this))
                .on("keypress", $.proxy(this.handleKeyPress, this));
            this.searchOverlay.searchPanel.on("click", "a", $.proxy(this.handleElementClick, this));
            this.searchOverlay.listPanel.on("click", "a", $.proxy(this.handleElementClick, this));
            this.remoteLocationButton.on("click", "", $.proxy(this.handleRemoteLocationSelected, this));
        },
        handleInput: function(e) {

            // Handle arrow down from the input
            if (e.keyCode === 40 && this.searchOverlay.input.is(":focus")) {
                searchOverlay.getVisiblePanel().find("a").first().focus();
                return;
            }

            const query = e.currentTarget.value.trim();

            // Show/hide results when filtering from input
            if (query.length >= this.settings.minQueryCharLength) {
                this.searchOverlay.searchPanel.empty();

                const searchOverlay = this.searchOverlay;

                this.searchOverlay.listPanel.find("a").each(function () {
                    const menuItem = $(this);
                    const text = menuItem.text();

                    if (menuItem.hasClass("search-box-listitem-location") && text.toLowerCase().startsWith(query.toLowerCase())) {
                        const newMenuItem = menuItem.clone();
                        const formatedText = $.utils.replaceString(newMenuItem.text(), query, `<b>$&</b>`);
                        newMenuItem.html(formatedText);
                        searchOverlay.searchPanel.append(newMenuItem);
                    }
                });

                this.searchOverlay.showPanel(this.searchOverlay.searchPanel);
                this.searchOverlay.hidePanel(this.searchOverlay.listPanel);

                const resultCount = searchOverlay.searchPanel.children().length;

                if (resultCount === 0) {
                    this.searchOverlay.searchPanel.append(
                        `<a class="dropdown-item"><i>Inga träffar för ${query}<i></a>`);
                }

            } else {
                this.searchOverlay.showPanel(this.searchOverlay.listPanel);
                this.searchOverlay.hidePanel(this.searchOverlay.searchPanel);
            }

        },
        handleKeyPress: function (e) {
            // Handle enter press when enter is pressed the first location should be selected
            if (e.keyCode === 13) {
                const query = e.currentTarget.value.trim();
                e.preventDefault();
                const firstItem = this.searchOverlay.searchPanel.find("a.search-box-listitem").first();
                if (query.length >= this.settings.minQueryCharLength && firstItem.length) {
                    this.searchOverlay.input.val(firstItem.text().trim());
                    this.searchOverlay.form.find("[name=ll]").val(firstItem.data("id"));
                    this.searchOverlay.hideOverlay();
                    $("#search-btn").focus();
                } else {
                    this.searchOverlay.hideOverlay();
                    $("#search-btn").focus();
                }
                return false;
            }
        },
        handleElementClick: function (e) {
            e.preventDefault();
            const selectedElement = $(e.target);
            const locationName = selectedElement.text().trim();
            const locationId = selectedElement.data("id");
            const remoteLocationId = 10851;
            this.cityLocationId = locationId;
            this.searchOverlay.input.val(locationName);
            this.searchOverlay.form.find("[name=ll]").val(locationId);
            this.searchOverlay.hideOverlay();
            $("#search-btn").focus();
            if (locationId !== remoteLocationId) {
                $("#mobile-remote-location").removeClass("d-none");
            }
        },
        handleRemoteLocationSelected: function (e) {
            e.preventDefault();
            const selectedElement = $(e.currentTarget.firstElementChild);
            if (selectedElement.is(':checked')) {
                selectedElement.removeAttr("checked");
                this.searchOverlay.form.find("[name=ll]").val(this.cityLocationId);
            } else {
                selectedElement.attr("checked", true);
                this.searchOverlay.form.find("[name=ll]").val([this.cityLocationId, selectedElement.data("id")]);
            }
        },
    });

})(jQuery, window);
